import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=081bf531&scoped=true&"
import script from "./OrganisationList.vue?vue&type=script&lang=js&"
export * from "./OrganisationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationList.vue?vue&type=style&index=0&id=081bf531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bf531",
  null
  
)

export default component.exports